"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRole = exports.UserInvitationStatus = exports.UserAuthenticationResult = exports.LicenseType = void 0;
/**
 *
 * @export
 */
exports.LicenseType = {
    ManuallyAdded: 'ManuallyAdded',
    FromSubscription: 'FromSubscription',
    FromOrganization: 'FromOrganization'
};
/**
 *
 * @export
 */
exports.UserAuthenticationResult = {
    Success: 'Success',
    CredentialsInvalid: 'CredentialsInvalid',
    TokenInvalid: 'TokenInvalid',
    TokenExpired: 'TokenExpired',
    TokenRevoked: 'TokenRevoked',
    SessionInvalid: 'SessionInvalid',
    SessionExpired: 'SessionExpired',
    SessionRevoked: 'SessionRevoked',
    SessionNotFound: 'SessionNotFound'
};
/**
 *
 * @export
 */
exports.UserInvitationStatus = {
    Pending: 'Pending',
    Accepted: 'Accepted',
    Declined: 'Declined',
    Revoked: 'Revoked',
    Error: 'Error'
};
/**
 *
 * @export
 */
exports.UserRole = {
    Basic: 'Basic',
    Owner: 'Owner',
    Managed: 'Managed'
};
//# sourceMappingURL=index.js.map